export enum PurchaseOrderReceivingStatus {
  NotReceived = 'not_received',
  PartiallyReceived = 'partially_received',
  Received = 'received',
}
